/**
 * Whether a follow-up editor control may be seeded from the template.
 * User edits mark the control dirty via the editor CVA; do not overwrite those.
 * Missing controls (e.g. cycle reply) must not be treated as seedable.
 */
export function canSeedFollowUpMessage(control: {
  dirty?: boolean;
} | null | undefined): boolean {
  return !!control && !control.dirty;
}

/**
 * Build the future_message value sent to the follow-up API.
 */
export function buildFollowUpFutureMessage(
  sameMessage: boolean,
  message1: string,
  message2: string,
  message3: string,
): string | string[] {
  if (sameMessage) {
    return message1;
  }
  return [message1, message2, message3];
}
